export enum DragTypeEnum {
  group = 'group',
  checkboxList = 'checkboxList',
  subtask = 'subtask',
  DataTransferItemList = 'DataTransferItemList',
}
